import { animate } from "framer-motion";
import React, { useEffect, useRef } from "react";

export default ({ from, to, decimals, addition }) => {
    const nodeRef = useRef();

    useEffect(() => {
        const node = nodeRef.current;

        let affix = (addition) ? addition : "";

        const controls = animate(from, to, {
            duration: 10,
            onUpdate(value) {
                node.textContent = value.toFixed(decimals) + affix;
            }
        });

        return () => controls.stop();
    }, [from, to]);

    return <p className="text-white text-center font-custom font-medium text-8xl xs:text-4xl sm:text-4xl md:text-4xl lg:text-8xl" ref={nodeRef}>+</p>;
}